import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();
  const canonical = `https://cryptobag.net${location.pathname}`;

  return (
    <>
      <Helmet>
        <title>Page Not Found | CryptoBag</title>
        <meta
          name="description"
          content="The requested page could not be found. Browse live crypto prices, coin pages, and market news from CryptoBag."
        />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={canonical} />
      </Helmet>

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-gray-800/60 backdrop-blur-sm border border-gray-700/50 p-10 rounded-xl shadow-2xl text-center space-y-6">
          <div className="space-y-3">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-indigo-400">404</p>
            <h1 className="text-4xl font-black text-white tracking-tighter">Page Not Found</h1>
            <p className="text-gray-400 max-w-2xl mx-auto">
              The URL you requested does not exist. Continue with the main market pages below.
            </p>
          </div>

          <nav className="flex flex-wrap items-center justify-center gap-4 text-sm font-bold uppercase tracking-widest">
            <Link to="/" className="text-indigo-400 hover:text-indigo-300 transition-colors">Home</Link>
            <Link to="/prices" className="text-indigo-400 hover:text-indigo-300 transition-colors">Prices</Link>
            <Link to="/articles" className="text-indigo-400 hover:text-indigo-300 transition-colors">Articles</Link>
          </nav>
        </div>
      </div>
    </>
  );
};

export default NotFound;
